import AuthService from "../auth/auth_service";
import axios from "axios";
export default class OperatorService extends AuthService {
  constructor() {
    super("operador");
  }

  findActive() {
    return this.execute("GET", "/ativos").then((res) => res.data);
  }

  findByPerson(id) {
    return axios({
      method: "get",
      url: this.api_url + "operador/person/" + id,
      withCredentials: true,
    }).then((res) => res.data);
  }

  upload(id, file) {
    return axios({
      method: "PUT",
      url: `${this.api_url}operador/upload/${id}`,
      withCredentials: true,
      data: { File: file },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
